
<div class="homeGrid">
    <app-calendar (EventClicked)="CalendarEventClicked($event)" [events]="callSchedule.events" class="calendarHolder"
                  id="cal-orders"></app-calendar>
    <div (click)="startRecentReview(mostRecentPlacedOrder)" class="recentOrderCard card pointer " id="card-recentOrder">
        <div class="panel"></div>
        <div class="contentHolder center">
            <p class="cardHeader">Recent Order</p>
            <p *ngIf="mostRecentPlacedOrder"> {{mostRecentPlacedOrder.callDate | date:'MMM dd, yyyy':'GMT'}}</p>
            <p *ngIf="!mostRecentPlacedOrder">No Order's Placed</p>
        </div>
    </div>
    <div (click)="StartNextOrder(nextOrderDue)" class="nextOrderCard card pointer" id="card-nextOrder">
        <div class="contentHolder center">
            <p class="cardHeader">Next Scheduled Order</p>
            <p *ngIf="nextOrderDue">{{nextOrderDue.callDate |  date:'MMM dd, yyyy': 'GMT'}}</p>
            <p *ngIf="!nextOrderDue">No Order's Scheduled</p>

        </div>
    </div>
    <div (click)="startUnscheduledOrder()" class="unscheduledOrderCard card pointer " id="card-unscheduled">
        <div class="contentHolder center">
            <p class="cardHeader">No orders scheduled?</p>
            <p>Start an Unscheduled Order</p>
        </div>
    </div>
</div>
<div kendoDialogContainer></div>
